import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAMS } from '../constants/searchParamNames';
import { IoChevronDown } from 'react-icons/io5';
import { TbMapPin } from 'react-icons/tb';
import '../scss/location-list-container.scss';

const LocationListContainer = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const locations = searchParams.get(SEARCH_PARAMS.LOCATION) ?? '';

  const handleOpen = () => {
    searchParams.set(SEARCH_PARAMS.LOCATIONS_MODAL, 'true');
    setSearchParams(searchParams);
  };

  return (
    <>
      <div className="location-list-container" onClick={handleOpen}>
        <div className="pin-container">
          <TbMapPin width={25} height={25} />
        </div>

        <div className="location-list-item">
          {locations
            ? locations
                .split(',')
                .join(', ')
                .replace(/ - sve opštine/g, '')
            : 'Izaberi lokaciju'}
        </div>

        <div className="chevron-container">
          <IoChevronDown />
        </div>
      </div>
    </>
  );
};

export default LocationListContainer;
